"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
exports.__esModule = true;
exports.assignFromAccountRaw = exports.assignToAccountRaw = exports.fromTronResourcesRaw = exports.toTronResourcesRaw = void 0;
var bignumber_js_1 = require("bignumber.js");
var toTronResourcesRaw = function (_a) {
    var frozen = _a.frozen, delegatedFrozen = _a.delegatedFrozen, votes = _a.votes, tronPower = _a.tronPower, energy = _a.energy, bandwidth = _a.bandwidth, unwithdrawnReward = _a.unwithdrawnReward, lastWithdrawnRewardDate = _a.lastWithdrawnRewardDate, lastVotedDate = _a.lastVotedDate, cacheTx = _a.cacheTransactionInfoById;
    var frozenBandwidth = frozen.bandwidth;
    var frozenEnergy = frozen.energy;
    var delegatedFrozenBandwidth = delegatedFrozen.bandwidth;
    var delegatedFrozenEnergy = delegatedFrozen.energy;
    var cacheTransactionInfoById = {};
    for (var k in cacheTx) {
        var _b = cacheTx[k], fee = _b.fee, blockNumber = _b.blockNumber, withdraw_amount = _b.withdraw_amount, unfreeze_amount = _b.unfreeze_amount;
        cacheTransactionInfoById[k] = [
            fee,
            blockNumber,
            withdraw_amount,
            unfreeze_amount,
        ];
    }
    return {
        frozen: {
            bandwidth: frozenBandwidth
                ? {
                    amount: frozenBandwidth.amount.toString(),
                    expiredAt: frozenBandwidth.expiredAt.toISOString()
                }
                : undefined,
            energy: frozenEnergy
                ? {
                    amount: frozenEnergy.amount.toString(),
                    expiredAt: frozenEnergy.expiredAt.toISOString()
                }
                : undefined
        },
        delegatedFrozen: {
            bandwidth: delegatedFrozenBandwidth
                ? {
                    amount: delegatedFrozenBandwidth.amount.toString()
                }
                : undefined,
            energy: delegatedFrozenEnergy
                ? {
                    amount: delegatedFrozenEnergy.amount.toString()
                }
                : undefined
        },
        votes: votes,
        tronPower: tronPower,
        energy: energy.toString(),
        bandwidth: {
            freeUsed: bandwidth.freeUsed.toString(),
            freeLimit: bandwidth.freeLimit.toString(),
            gainedUsed: bandwidth.gainedUsed.toString(),
            gainedLimit: bandwidth.gainedLimit.toString()
        },
        unwithdrawnReward: unwithdrawnReward.toString(),
        lastWithdrawnRewardDate: lastWithdrawnRewardDate
            ? lastWithdrawnRewardDate.toISOString()
            : undefined,
        lastVotedDate: lastVotedDate ? lastVotedDate.toISOString() : undefined,
        cacheTransactionInfoById: cacheTransactionInfoById
    };
};
exports.toTronResourcesRaw = toTronResourcesRaw;
var fromTronResourcesRaw = function (_a) {
    var frozen = _a.frozen, delegatedFrozen = _a.delegatedFrozen, votes = _a.votes, tronPower = _a.tronPower, energy = _a.energy, bandwidth = _a.bandwidth, unwithdrawnReward = _a.unwithdrawnReward, lastWithdrawnRewardDate = _a.lastWithdrawnRewardDate, lastVotedDate = _a.lastVotedDate, cacheTransactionInfoByIdRaw = _a.cacheTransactionInfoById;
    var frozenBandwidth = frozen.bandwidth;
    var frozenEnergy = frozen.energy;
    var delegatedFrozenBandwidth = delegatedFrozen.bandwidth;
    var delegatedFrozenEnergy = delegatedFrozen.energy;
    var cacheTransactionInfoById = {};
    if (cacheTransactionInfoByIdRaw) {
        for (var k in cacheTransactionInfoByIdRaw) {
            var _b = __read(cacheTransactionInfoByIdRaw[k], 4), fee = _b[0], blockNumber = _b[1], withdraw_amount = _b[2], unfreeze_amount = _b[3];
            cacheTransactionInfoById[k] = {
                fee: fee,
                blockNumber: blockNumber,
                withdraw_amount: withdraw_amount,
                unfreeze_amount: unfreeze_amount
            };
        }
    }
    return {
        frozen: {
            bandwidth: frozenBandwidth
                ? {
                    amount: new bignumber_js_1.BigNumber(frozenBandwidth.amount),
                    expiredAt: new Date(frozenBandwidth.expiredAt)
                }
                : undefined,
            energy: frozenEnergy
                ? {
                    amount: new bignumber_js_1.BigNumber(frozenEnergy.amount),
                    expiredAt: new Date(frozenEnergy.expiredAt)
                }
                : undefined
        },
        delegatedFrozen: {
            bandwidth: delegatedFrozenBandwidth
                ? {
                    amount: new bignumber_js_1.BigNumber(delegatedFrozenBandwidth.amount)
                }
                : undefined,
            energy: delegatedFrozenEnergy
                ? {
                    amount: new bignumber_js_1.BigNumber(delegatedFrozenEnergy.amount)
                }
                : undefined
        },
        votes: votes,
        tronPower: tronPower,
        energy: new bignumber_js_1.BigNumber(energy),
        bandwidth: {
            freeUsed: new bignumber_js_1.BigNumber(bandwidth.freeUsed),
            freeLimit: new bignumber_js_1.BigNumber(bandwidth.freeLimit),
            gainedUsed: new bignumber_js_1.BigNumber(bandwidth.gainedUsed),
            gainedLimit: new bignumber_js_1.BigNumber(bandwidth.gainedLimit)
        },
        unwithdrawnReward: new bignumber_js_1.BigNumber(unwithdrawnReward),
        lastWithdrawnRewardDate: lastWithdrawnRewardDate
            ? new Date(lastWithdrawnRewardDate)
            : undefined,
        lastVotedDate: lastVotedDate ? new Date(lastVotedDate) : undefined,
        cacheTransactionInfoById: cacheTransactionInfoById
    };
};
exports.fromTronResourcesRaw = fromTronResourcesRaw;
function assignToAccountRaw(account, accountRaw) {
    var tronAccount = account;
    if (tronAccount.tronResources) {
        accountRaw.tronResources = (0, exports.toTronResourcesRaw)(tronAccount.tronResources);
    }
}
exports.assignToAccountRaw = assignToAccountRaw;
function assignFromAccountRaw(accountRaw, account) {
    var tronResourcesRaw = accountRaw.tronResources;
    if (tronResourcesRaw)
        account.tronResources =
            (0, exports.fromTronResourcesRaw)(tronResourcesRaw);
}
exports.assignFromAccountRaw = assignFromAccountRaw;
//# sourceMappingURL=serialization.js.map